import { AUTH_USER_SUCCESS, LOGOUT_USER, UPDATE_USER_FIELDS } from './types'

const userState = {
    name: '',
    email: '',
    role: '',
    phone: '',
    fantasy: '',
    picture: '',
    company_secret: '',
    isAuthenticated: false
}

const userReducer = (state, actions) => {

    const { type, payload } = actions

    switch (type) {
        
        case AUTH_USER_SUCCESS: {

            return {
                ...state,
                name: payload.name,
                email: payload.email,
                phone: payload.phone,
                role: payload.role.role_id,
                fantasy: payload.fantasy,
                picture: payload.picture,
                company_secret: payload.company_secret,
                isAuthenticated: true
            }

        }
        case LOGOUT_USER: {

            return {
                name: '',
                email: '',
                role: '',
                phone: '',
                fantasy: '',
                picture: '',
                company_secret: '',
                isAuthenticated: false
            }

        }
        case UPDATE_USER_FIELDS: {
            return {
                ...state,
                ...payload
            }

        }
        default: {
          return state
        }
    }
}

export { userReducer as default, userState }